import React from 'react';
import PropTypes from 'prop-types';
import FormFieldMessage from './FormFieldMessage';

const FormTextField = ({
  type,
  id,
  name,
  label,
  value,
  placeholder,
  required,
  onBlur,
  onChange,
  errorMessage,
}) => (
  <div className="field">
    <label htmlFor={id} className="label">
      {label}
      <div className="control">
        {type === 'textarea' ? (
          <textarea
            id={id}
            name={name}
            value={value || ''}
            placeholder={placeholder}
            className={`textarea ${errorMessage ? 'is-danger' : ''}`}
            {...(required ? { required, 'aria-required': 'true' } : {})}
            onBlur={onBlur}
            onChange={onChange}
          />
        ) : (
          <input
            type={type}
            id={id}
            name={name}
            value={value || ''}
            placeholder={placeholder}
            className={`input ${errorMessage ? 'is-danger' : ''}`}
            {...(required ? { required, 'aria-required': 'true' } : {})}
            onBlur={onBlur}
            onChange={onChange}
          />
        )}
      </div>
    </label>
    <FormFieldMessage message={errorMessage} />
  </div>
);

FormTextField.defaultProps = {
  value: '',
  onBlur: () => {},
  onChange: () => {},
  errorMessage: '',
};

FormTextField.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default FormTextField;



// WEBPACK FOOTER //
// ./src/components/FormTextField.js